import { render } from "./OrgSignup.vue?vue&type=template&id=099c55c6&scoped=true"
import script from "./OrgSignup.vue?vue&type=script&lang=js"
export * from "./OrgSignup.vue?vue&type=script&lang=js"

import "./OrgSignup.vue?vue&type=style&index=0&id=099c55c6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099c55c6"]])

export default __exports__